import { accessAsset, anyAsset, AssetUIModel, CanPipe } from '@thehubz/client/core';
import { Asset } from '@thehubz/client/data-access-api';
import { CustomClients } from '@thehubz/shared/branding';
import { AssetMetadata } from '../../components/asset-detail-view/asset-info/models/asset-info.interface';

const AnyAsset = anyAsset;
const AccessAsset = accessAsset;

export const Channel = [
  { _id: 'communitystars', name: 'Community Stars' },
  { _id: 'directselling', name: 'Direct Selling' },
  { _id: 'editorialcontent', name: 'Editorial content' },
  { _id: 'general', name: 'General' },
  { _id: 'informationninfographics', name: 'Information/Infographics' },
  { _id: 'magazinesnbooks', name: 'Magazines/Books' },
  { _id: 'newslettersnemailing', name: 'Newsletters/Emailing' },
  { _id: 'paidads', name: 'Paid Ads' },
  { _id: 'printedmaterial', name: 'Printed material' },
  { _id: 'retail', name: 'Retail' },
  { _id: 'social_media', name: 'Social Media' },
  { _id: 'toolkitntemplates', name: 'Toolkit/Templates' },
  { _id: 'website', name: 'Website' },
];

export const Product = [
  { _id: 'air_purifier', name: 'Air purifier', brands: ['kobold'] },
  { _id: 'bimby_friend', name: 'Bimby friend', brands: ['bimby'] },
  { _id: 'cookidoo', name: 'Cookidoo', brands: ['thermomix', 'bimby'] },
  { _id: 'eb400', name: 'EB400', brands: ['kobold'] },
  { _id: 'eb420s', name: 'EB420s', brands: ['folletto'] },
  { _id: 'ebb100', name: 'EBB100', brands: ['kobold', 'folletto'] },
  { _id: 'folletto_app', name: 'Folletto App', brands: ['folletto'] },
  { _id: 'forerunners', name: 'Forerunners', brands: ['folletto', 'kobold', 'thermomix'] },
  { _id: 'hd60', name: 'HD60', brands: ['kobold'] },
  { _id: 'hd65s', name: 'HD65s', brands: ['folletto'] },
  { _id: 'mykobold', name: 'Mykobold', brands: ['kobold'] },
  { _id: 'pb440', name: 'PB440', brands: ['kobold'] },
  { _id: 'pb440s', name: 'PB440s', brands: ['folletto'] },
  { _id: 'sp530s', name: 'SP530s', brands: ['folletto'] },
  { _id: 'sp600', name: 'SP600', brands: ['kobold'] },
  { _id: 'sp600s', name: 'SP600s', brands: ['folletto'] },
  { _id: 'spb100', name: 'SPB100', brands: ['kobold'] },
  { _id: 'thermomix_friend', name: 'Thermomix friend', brands: ['thermomix'] },
  { _id: 'tm31', name: 'TM31', brands: ['thermomix', 'bimby'] },
  { _id: 'tm7', name: 'TM7', brands: ['thermomix', 'bimby'] },
  { _id: 'tm5', name: 'TM5', brands: ['thermomix', 'bimby'] },
  { _id: 'tm6', name: 'TM6', brands: ['thermomix', 'bimby'] },
  { _id: 'vb100', name: 'VB100', brands: ['kobold', 'folletto'] },
  { _id: 'vc100', name: 'VC100', brands: ['kobold', 'folletto'] },
  { _id: 'vf200', name: 'VF200', brands: ['kobold'] },
  { _id: 'vf200s', name: 'VF200s', brands: ['folletto'] },
  { _id: 'vg100', name: 'VG100', brands: ['kobold', 'folletto'] },
  { _id: 'vk200', name: 'VK200', brands: ['kobold'] },
  { _id: 'vk220s', name: 'VK220s', brands: ['folletto'] },
  { _id: 'vk7', name: 'VK7', brands: ['kobold'] },
  { _id: 'vm7', name: 'VM7', brands: ['kobold', 'folletto'] },
  { _id: 'vr200', name: 'VR200', brands: ['kobold', 'folletto'] },
  { _id: 'vr300', name: 'VR300', brands: ['kobold', 'folletto'] },
  { _id: 'vt300', name: 'VT300', brands: ['kobold', 'folletto'] },
];

export const SubCategory = [
  {
    _id: 'accessories',
    name: 'Accessories',
    products: [
      'eb400',
      'eb420s',
      'ebb100',
      'forerunners',
      'hd60',
      'hd65s',
      'pb440',
      'pb440s',
      'sp530s',
      'sp600',
      'sp600s',
      'tm31',
      'tm5',
      'tm6',
      'vb100',
      'vc100',
      'vf200',
      'vf200s',
      'vg100',
      'vk200',
      'vk220s',
      'vr200',
      'vr300',
      'vt300',
    ],
  },
  {
    _id: 'consumables',
    name: 'Consumables',
    products: [
      'eb400',
      'ebb100',
      'forerunners',
      'hd60',
      'pb440',
      'sp600',
      'tm31',
      'tm5',
      'tm6',
      'vb100',
      'vc100',
      'vf200',
      'vg100',
      'vk200',
      'vr200',
      'vr300',
      'vt300',
    ],
  },
  {
    _id: 'forerunner',
    name: 'Forerunner',
    products: ['eb400', 'ebb100', 'hd60', 'pb440', 'sp600', 'vb100', 'vc100', 'vf200', 'vg100', 'vk200', 'vr200', 'vr300', 'vt300'],
  },
];

export const Subject = [
  { _id: 'advisor', name: 'Advisor' },
  { _id: 'awardsnlabels', name: 'Awards & Labels' },
  { _id: 'campaign', name: 'Campaign' },
  { _id: 'foodlifestlye', name: 'Food Lifestlye' },
  { _id: 'generalinformation', name: 'General information' },
  { _id: 'historical', name: 'Historical' },
  { _id: 'peoplestory', name: 'People Story' },
  { _id: 'productcloseup', name: 'Product Close-up' },
  { _id: 'producthowto', name: 'Product How-To' },
  { _id: 'productinuse', name: 'Product in use' },
  { _id: 'productlifestyle', name: 'Product Lifestyle' },
  { _id: 'productstandalone', name: 'Product Standalone' },
  { _id: 'recipecontent', name: 'Recipe content' },
];

export const Category = [
  { _id: 'archive', name: 'Archive' },
  { _id: 'company', name: 'Company' },
  { _id: 'food', name: 'Food' },
  { _id: 'merchandise', name: 'Merchandise' },
  { _id: 'objects', name: 'Objects' },
  { _id: 'people', name: 'People' },
  { _id: 'product', name: 'Product' },
  { _id: 'technical', name: 'Technical' },
];

export const vorwerkAssetMetadataConfig = (assetInfo: AssetUIModel, canPipe: CanPipe): AssetMetadata => {
  const status: { id: Asset.StatusEnum; name: string }[] = [{ id: Asset.StatusEnum.Pending, name: $localize`Pending` }];
  /**
   * Below condition is used to check whether a user have right to set asset status 'Approved'.
   */
  if (canPipe.transform(AnyAsset, 'update.allstatus')) {
    status.push({ id: Asset.StatusEnum.Approved, name: $localize`Approved` });
  }
  /**
   * Below condition is used to check whether a user have right to set asset status 'Archived'.
   */
  if (canPipe.transform(AnyAsset, 'archived')) {
    status.push({
      id: Asset.StatusEnum.Archived,
      name: $localize`Archived`,
    });
  }
  return {
    customerName: CustomClients.Vorwerk,
    metadata: [
      {
        fieldLabel: $localize`Name`,
        editable: true,
        formControlName: 'name',
      },
      {
        fieldLabel: $localize`Status`,
        editable: true,
        formControlName: 'status',
        options: status,
      },
      {
        fieldLabel: $localize`Domains`,
        editable: true,
        formControlName: 'domains',
        options: [],
        formFieldsGroup: [
          {
            fieldLabel: $localize`Domain`,
            editable: true,
            formControlName: 'agency',
            options: [],
          },
          {
            fieldLabel: $localize`Location`,
            editable: true,
            formControlName: 'client',
            options: [],
          },
          {
            fieldLabel: $localize`Brand`,
            editable: true,
            formControlName: 'brand',
            options: [],
          },
          {
            fieldLabel: $localize`Category`,
            editable: true,
            formControlName: 'category',
            options: [],
          },
          {
            fieldLabel: $localize`Product`,
            editable: true,
            formControlName: 'product',
            options: [],
          },
          {
            fieldLabel: $localize`Sub-category`,
            editable: true,
            formControlName: 'subcategory',
            options: [],
          },
        ],
      },
      {
        fieldLabel: $localize`Created at`,
        editable: false,
        formControlName: 'createdAt',
      },
      {
        fieldLabel: $localize`Created by`,
        editable: false,
        formControlName: 'createdBy',
      },
      {
        fieldLabel: $localize`Modified at`,
        editable: false,
        formControlName: 'updatedAt',
      },
      {
        fieldLabel: $localize`Modified by`,
        editable: false,
        formControlName: 'updatedBy',
      },
      {
        fieldLabel: $localize`Description`,
        editable: true,
        formControlName: 'description',
        options: [],
      },
      {
        fieldLabel: $localize`Planned for deletion`,
        editable: true,
        formControlName: 'plannedDeletion',
        options: [],
      },
      {
        fieldLabel: $localize`Publish Start Date`,
        editable: assetInfo && assetInfo.accessKeys ? canPipe.transform(AccessAsset(assetInfo), 'update.allstatus') : true,
        formControlName: 'publishStartDate',
      },
      {
        fieldLabel: $localize`Publish End Date`,
        editable: assetInfo && assetInfo.accessKeys ? canPipe.transform(AccessAsset(assetInfo), 'update.allstatus') : true,
        formControlName: 'publishEndDate',
      },
    ],
  };
};
